export const calculateValidity = (expiresAt: string): string => {
  if (!expiresAt) return 'نامشخص'

  const now = new Date()
  const expiry = new Date(expiresAt)
  const diffTime = expiry.getTime() - now.getTime()

  if (Number.isNaN(expiry.getTime())) return "نامشخص";

  const absMinutes = Math.floor(Math.abs(diffTime) / (1000 * 60));
  const absHours = Math.floor(absMinutes / 60);
  const absDays = Math.floor(absHours / 24);
  const absMonths = Math.floor(absDays / 30);

  const remainingHours = absHours % 24;
  const remainingMinutes = absMinutes % 60;

  const parts: string[] = [];

  if (absDays >= 30) {
    parts.push(`${absMonths} ماه`);
    const remainingDays = absDays % 30;
    if (remainingDays > 0) parts.push(`${remainingDays} روز`);
  } else {
    if (absDays > 0) parts.push(`${absDays} روز`);
  }

  if (absDays < 30 && remainingHours > 0) {
    parts.push(`${remainingHours} ساعت`);
  }

  if (absDays === 0 && remainingMinutes > 0) {
    parts.push(`${remainingMinutes} دقیقه`);
  }

  if (parts.length === 0) {
    return diffTime < 0 ? "همین الان منقضی شده" : "کمتر از یک دقیقه";
  }

  const duration = parts.join(" و ");

  return diffTime < 0 ? `${duration} پیش` : `در ${duration}`;
};
